/* eslint-disable max-len */
import React, { Component } from 'react'
import Content from './Content'

export default class ProjectPage extends Component {
  render() {
    return (
      <Content>
        <div className="info">
          <h2>
            MUSbi – der direkte Weg zu qualitativ wertvollen
            museumspädagogischen Programmen und Themenführungen in Oberfranken,
            Unterfranken, Niederbayern und der Oberpfalz
          </h2>
          <p>
            Am 20. November 2014 starteten Kultusminister Dr. Ludwig Spaenle und
            Bezirkstagspräsident Dr. Günther Denzler die Web-App musbi.de.
          </p>
          <p>
            Entwickelt wurde die Web-App im Rahmen eines bayernweiten
            Modellprojekts der KulturServiceStelle des Bezirks Oberfranken und
            des Bayerischen Staatsministeriums für Bildung und Kultus,
            Wissenschaft und Kunst.
          </p>
          <p>
            Ziel war es, eine Schnittstelle zwischen den beiden Institutionen
            Museum und Schule in Form einer Internetplattform zu schaffen.
            Entstanden ist dabei die Web-App musbi.de, die Lehrer und
            Schulklassen gezielt über qualitativ wertvolle museumspädagogische
            Programme und Themenführungen informiert. Das Fachportal erleichtert
            Lehrkräften den Zugang zu Museen. Das Museum als außerschulischer
            Lern- und Bildungsort wird dadurch für Schulen attraktiver und die
            Zusammenarbeit zwischen Schulen und Museen wird langfristig
            gesichert.
          </p>
          <p>
            Das Web-Angebot MUSbi erhebt einen pädagogischen Qualitätsanspruch.
            Durch einen Administrator wird sichergestellt, dass die der Web-App
            zugrundeliegenden Qualitätskriterien eingehalten werden und
            verschiedene pädagogische Methoden und Materialien in enger
            Abstimmung mit den bayerischen Lehrplänen zur Anwendung kommen.
            Durch die ständige Überprüfung und Aktualisierung der Angebote haben
            Schulen und Lehrer Gewissheit, dass die Qualität der Veranstaltungen
            gesichert ist und diese genau auf die Bedürfnisse und Ansprüche der
            jeweiligen Schulklassen zugeschnitten sind.
          </p>
          <p>
            Seit Juni 2017 steht MUSbi den Museen im Bezirk Unterfranken zur
            Verfügung und seit Januar 2020 auch den Museen in den Bezirken
            Niederbayern und Oberpfalz.
          </p>
          <h3>Für Lehrkräfte</h3>
          <p>
            MUSbi ist der direkte Weg zu guten museumspädagogischen Programmen
            und Themenführungen. Finden Sie als Lehrkraft über diese Web-App das
            passende außerschulische Lernangebot für Ihre Klasse! Wählen Sie
            nach den „Kategorien“ Schulart und Jahrgang, Fächer und Landkreis
            die geeignete Aktion aus. Haben Sie für Ihre Aktivität etwas
            gefunden – ob unterrichtliche Exkursion oder Wandertag – müssen Sie
            nur noch mit dem Museum Kontakt aufnehmen und die Veranstaltung
            buchen. Alle wichtigen Informationen, die Sie benötigen, werden
            Ihnen in einer Übersicht angezeigt.
          </p>
          <p>
            Ihr Vorteil: Entscheiden Sie sich für ein MUSbi-Angebot, ist die
            pädagogische Qualität der Veranstaltung gesichert. Sämtliche
            angebotenen Programme wurden überprüft. Die KulturServiceStelle des
            Bezirks Oberfranken stellt damit sicher, dass pädagogische Methoden
            und Materialien sowie Inhalte und Themen der einzelnen Angebote eng
            mit den bayerischen Lehrplänen abgestimmt sind.
          </p>
          <p>
            Nach dem Besuch sind Sie und Ihre Schüler eingeladen, die gebuchte
            Veranstaltung zu bewerten. Den schnellen Zugang bekommen Sie über
            einen QR-Code, den Sie im Museum erhalten.
          </p>
          <h3>Für Museen</h3>
          <p>
            MUSbi bietet Ihrem Museum eine ideale Plattform für Ihre
            Museumspädagogik: Hier können Sie kostenlos für Ihre guten
            museumspädagogischen Programme und Themenführungen direkt bei den
            Zielgruppen – Lehrkräften und Schülern – werben. Besuchen Sie eine
            der Fortbildungsveranstaltungen für MUSbi und informieren Sie sich
            über die qualitativen Anforderungen. Mit Ihrem persönlichen
            Zugangscode können Sie dann Ihre Angebote einstellen. Wenn Ihr
            Angebot auf musbi.de erscheint, garantieren wir gemeinsam für die
            Qualität und den inhaltlichen Bezug zu den bayerischen Lehrplänen
            und sichern den Gruppen zu, dass lehrplankonforme Methoden und
            Materialien, wie auf MUSbi angekündigt, zur Anwendung kommen.{' '}
          </p>
          <p>
            Gerne beraten wir Sie, damit auch Ihr museumspädagogisches Angebot
            auf MUSbi erscheint und Sie damit zeigen, dass Sie
            qualitätsorientiert vermitteln!
          </p>
          <strong>Ihre Ansprechpartner:</strong>
          <br />
          <br />
          Oberfranken
          <br />
          Dirk Eilers, StR (RS)
          <br />
          oberfranken@musbi.de
          <br />
          <br />
          Unterfranken
          <br />
          Alexandra Neuberger M.A., StDin
          <br />
          Telefon: 0931 7959-1716
          <br />
          unterfranken@musbi.de
          <br />
          <br />
          Niederbayern
          <br />
          Anja Klein, OStRin
          <br />
          Marion Seidl, OStRin
          <br />
          Sonja Then, StRin (RS)
          <br />
          niederbayern@musbi.de
          <br />
          <br />
          Oberpfalz
          <br />
          Sonja Then, StRin (RS)
          <br />
          oberpfalz@musbi.de
          <br />
          <h3>Für Schüler:</h3>
          <p>MUSbi – must be!</p>
          <p>
            Alle raus aus dem Klassenzimmer und mal wo anders was Neues
            erfahren…
          </p>
          <p>
            MUSbi zeigt dir die Museen, die Wissenswertes so gut rüberbringen,
            dass es dir und deiner Klasse Spaß macht. Schau einfach mal bei
            MUSbi, was für deine Klassenstufe angeboten wird. Sprich mit deinen
            Lehrkräften, sicher sind auch sie daran interessiert, Schulstoff
            interessanter zu vermitteln oder einen gelungenen Wandertag zu
            erleben. Und dann geht´s los ins MUSbi-Museum!
          </p>
          <p>
            MUSbi – die Web-App für qualifizierte museumspädagogische Angebote
            in Oberfranken, Unterfranken, Niederbayern und der Oberpfalz für
            Schulklassen.
          </p>
          <p>
            Das Museumspädagogisches Zentrum ist mit seinem "Netzwerk Schule und Museum in Bayern" Kooperationspartner im Projekt.
          </p>
        </div>
      </Content>
    )
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/ProjectPage.js